import styled from '@emotion/styled';
import { Segment } from 'semantic-ui-react';
import { Calendar } from 'components';
import { Timestamp } from '@britishcouncil/common-core';
import { useExamDatesForLocationsDistrictContext } from './useExamDatesForLocationsDistrictContext';
import { Footer } from '../common/Footer';
import { UnsavedChangesModal } from '../common/UnsavedChangesModal';

export const ExamDatesForLocationsDistrictContext = () => {
  const {
    date,
    locationName,
    isDataLoading,
    isLoadingButtons,
    isModified,
    isEditable,
    onSave,
    onDiscard,
    onDateChange,
    onDayClick,
    customCell,
  } = useExamDatesForLocationsDistrictContext();

  const initialDate = Timestamp.create(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    0,
    0,
    0,
    0
  );

  return (
    <S.Container>
      <UnsavedChangesModal isModified={isModified} />
      <S.BreadCrumbs>
        <S.HeaderText data-testid="location-name">{locationName}</S.HeaderText>
      </S.BreadCrumbs>

      <S.Content>
        <S.CalendarBackground>
          <Calendar
            initialDate={initialDate}
            customCell={customCell}
            onSelectedMonthChange={onDateChange}
            isLoading={isDataLoading}
            fromDate={Timestamp.addYears(-3)(Timestamp.now())}
            toDate={Timestamp.addYears(3)(Timestamp.now())}
            {...(isEditable ? { onDayClick: onDayClick } : {})}
          />
        </S.CalendarBackground>
      </S.Content>

      <Footer
        isModified={isModified}
        isLoadingButtons={isLoadingButtons}
        onDiscard={onDiscard}
        onSave={onSave}
      />
    </S.Container>
  );
};

const S = {
  BreadCrumbs: styled(Segment)`
    &.ui.segment {
      margin: unset;
      border-radius: unset;
    }
  `,
  Container: styled.div`
    height: calc(100vh - 50px);
    display: grid;
    grid-template-rows: [breadcrumb] 50px [content] 1fr [footer] 65px;
  `,
  HeaderText: styled.span`
    font-weight: 500;
    font-size: 16px !important;
  `,
  CalendarBackground: styled(Segment)`
    &.ui.segment {
      max-width: 75rem;
      margin: 1rem;
      height: fit-content;
    }
  `,
  Content: styled.div`
    display: flex;
    justify-content: center;
    overflow: auto;
  `,
};
